import React from 'react'
import { BarChart3, Users, MapPin } from 'lucide-react'

const UseCasesSection = () => {
  const useCases = [
    {
      icon: BarChart3,
      title: 'Marketing ROI',
      description: 'A boutique shop saw Instagram ads drive 40% more visitors than Facebook — and shifted budget to maximize results.',
      color: 'blue'
    },
    {
      icon: Users,
      title: 'Staffing Efficiency',
      description: 'A café noticed Thursday evenings were busier than expected and adjusted schedules, saving $500/month in labor.',
      color: 'green'
    },
    {
      icon: MapPin,
      title: 'Multi-Location Insight',
      description: 'A gym owner spotted one branch lagging behind others and fixed the issue before memberships dropped.',
      color: 'purple'
    }
  ]

  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue':
        return 'bg-blue-100 text-blue-600'
      case 'green':
        return 'bg-green-100 text-green-600'
      case 'purple':
        return 'bg-purple-100 text-purple-600'
      default:
        return 'bg-gray-100 text-gray-600'
    }
  }

  return (
    <section className="section-padding">
      <div className="container-padding">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            How small businesses put it to work.
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our customers use FlowBeatIQ to make smarter, faster decisions every week:
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {useCases.map((useCase, index) => {
            const Icon = useCase.icon
            return (
              <div key={index} className="card-shadow p-8 group">
                <div className={`w-12 h-12 ${getColorClasses(useCase.color)} rounded-lg flex items-center justify-center mb-4 transition-transform duration-200 group-hover:scale-110`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{useCase.title}</h3>
                <p className="text-gray-600">{useCase.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default UseCasesSection